import { getPortKey, getServiceKey } from './helpers';

export const vendorPorts = new Map<string, number | string>();
vendorPorts.set(getPortKey(80, 'tcp'), 'www'); // Just example already in IANA data file
vendorPorts.set(getServiceKey('www', 'tcp'), 80); // Just example already in IANA data file
// ***********************************************
vendorPorts.set(getServiceKey('whois', 'tcp'), 43);
vendorPorts.set(getServiceKey('dns', 'tcp'), 53);
vendorPorts.set(getServiceKey('dns', 'udp'), 53);
vendorPorts.set(getServiceKey('netbios-ss', 'udp'), 139);
vendorPorts.set(getServiceKey('imap4', 'tcp'), 143);
vendorPorts.set(getServiceKey('mobile-ip', 'udp'), 434);
vendorPorts.set(getServiceKey('pim-auto-rp', 'tcp'), 496);
vendorPorts.set(getServiceKey('pim-auto-rp', 'udp'), 496);
// conflict between two services: RFC 3164
// syslog https://tools.ietf.org/html/rfc3164
// shell - IANA https://www.iana.org/assignments/service-names-port-numbers/service-names-port-numbers.xhtml?search=514
vendorPorts.set(getServiceKey('syslog', 'tcp'), 514);
vendorPorts.set(getServiceKey('cmd', 'tcp'), 514);
vendorPorts.set(getServiceKey('rsh', 'tcp'), 514);
vendorPorts.set(getServiceKey('lpd', 'tcp'), 515);
vendorPorts.set(getServiceKey('rip', 'udp'), 520);
vendorPorts.set(getServiceKey('lotusnotes', 'tcp'), 1352);
vendorPorts.set(getServiceKey('citrix-ica', 'tcp'), 1494);
vendorPorts.set(getServiceKey('sqlnet', 'tcp'), 1521);
vendorPorts.set(getServiceKey('h323', 'tcp'), 1720);
vendorPorts.set(getServiceKey('ctiqbe', 'tcp'), 2748);
vendorPorts.set(getServiceKey('non500-isakmp', 'udp'), 4500);
vendorPorts.set(getServiceKey('secureid-udp', 'udp'), 5510);
vendorPorts.set(getServiceKey('pcanywhere-data', 'tcp'), 5631);
vendorPorts.set(getServiceKey('pcanywhere-status', 'udp'), 5632);
vendorPorts.set(getServiceKey('msrpc', 'tcp'), 135);
vendorPorts.set(getServiceKey('dhcp', 'udp'), 67);
vendorPorts.set(getServiceKey('onep-plain', 'tcp'), 15001);
// Juniper port names with no direct relation to protocol
// based on Juniper doc: https://www.juniper.net/documentation/en_US/junos/topics/reference/configuration-statement/applications-edit-destination-port.html
vendorPorts.set(getServiceKey('dhcp', '-'), 67);
vendorPorts.set(getServiceKey('kerberos-sec', '-'), 88);
vendorPorts.set(getServiceKey('krb-prop', '-'), 754);
vendorPorts.set(getServiceKey('krbupdate', '-'), 760);
vendorPorts.set(getServiceKey('radacct', '-'), 1813);
vendorPorts.set(getServiceKey('nfsd', '-'), 2049);
vendorPorts.set(getServiceKey('eklogin', '-'), 2105);
vendorPorts.set(getServiceKey('ekshell', '-'), 2106);
vendorPorts.set(getServiceKey('rkinit', '-'), 2108);
// Arista
vendorPorts.set(getServiceKey('multihop-bfd', 'udp'), 4784);
vendorPorts.set(getServiceKey('micro-bfd', 'udp'), 6784);
vendorPorts.set(getServiceKey('bfd', 'udp'), 3784);
vendorPorts.set(getServiceKey('mlag', 'tcp'), 4432);
vendorPorts.set(getServiceKey('mlag', 'udp'), 4432);
vendorPorts.set(getServiceKey('nat', 'tcp'), 4532);
vendorPorts.set(getServiceKey('cvx', 'tcp'), 50003);
vendorPorts.set(getServiceKey('cvx-cluster', 'tcp'), 50004);
vendorPorts.set(getServiceKey('godi', 'tcp'), 848);
vendorPorts.set(getServiceKey('gre', 'tcp'), 47);
vendorPorts.set(getServiceKey('la-maint', 'tcp'), 51);
vendorPorts.set(getServiceKey('lanz', 'tcp'), 50001);
vendorPorts.set(getServiceKey('mlag-arp-sync', 'tcp'), 50002);
vendorPorts.set(getServiceKey('netwnews', 'tcp'), 532);
vendorPorts.set(getServiceKey('godi', 'udp'), 848);
vendorPorts.set(getServiceKey('gtp-c', 'udp'), 2123);
vendorPorts.set(getServiceKey('gtp-prime', 'udp'), 3386);
vendorPorts.set(getServiceKey('gtp-u', 'udp'), 2152);
vendorPorts.set(getServiceKey('la-maint', 'udp'), 51);
vendorPorts.set(getServiceKey('nat', 'udp'), 4532);
vendorPorts.set(getServiceKey('sbfd', 'udp'), 7784);
vendorPorts.set(getServiceKey('sbfd-initiator', 'udp'), 47657);
vendorPorts.set(getServiceKey('gnmi', 'tcp'), 6030);
vendorPorts.set(getServiceKey('cvx-inband', 'tcp'), 9979);
vendorPorts.set(getServiceKey('cvx-inband-ssl', 'tcp'), 9978);
vendorPorts.set(getServiceKey('eco-dhcp', 'tcp'), 50005);
vendorPorts.set(getServiceKey('eco-ipfix', 'tcp'), 50006);
vendorPorts.set(getServiceKey('switch-cvx-ssl', 'tcp'), 9985);
// https://eos.arista.com/default-control-plane-acl-explained/ - 210 permit tcp any any eq 3333 - Used for Local License Server (CVX)
vendorPorts.set(getServiceKey('cvx-license', 'tcp'), 3333);
// Cisco APIC
vendorPorts.set(getServiceKey('ftpData', 'tcp'), 20);
vendorPorts.set(getServiceKey('ftpData', 'udp'), 20);
// HP Aruba CX - https://www.arubanetworks.com/techdocs/AOS-CX/10.12/PDF/cli_6300-6400.pdf
vendorPorts.set(getServiceKey('dhcp-server', 'udp'), 67);
vendorPorts.set(getServiceKey('dhcp-client', 'udp'), 68);
vendorPorts.set(getServiceKey('dce-rpc', 'tcp'), 135);
vendorPorts.set(getServiceKey('dce-rpc', 'udp'), 135);
vendorPorts.set(getServiceKey('snmp-trap', 'udp'), 162);
vendorPorts.set(getServiceKey('rdp', 'tcp'), 3389);
vendorPorts.set(getServiceKey('rdp', 'udp'), 3389);
vendorPorts.set(getServiceKey('nat-t', 'udp'), 4500);
